import { useState } from "react";
import { saveUnitDetails } from "../Api/UnitMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const UnitMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [unitData, setUnitData] = useState({
    code: "",
    description: "",
    type: "",
  });

  const unitTypes = [
    { value: "Weight", label: "Weight" },
    { value: "Distance", label: "Distance" },
    { value: "Height", label: "Height" },
    { value: "Count", label: "Count" },
  ];

  const handleChange = (e) => {
    setUnitData({ ...unitData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      await saveUnitDetails(unitData, userId);
      toast.success("🦄 Unit Added Successfully");
      setUnitData({
        code: "",
        description: "",
        type: "",
      });
      navigate("/viewUnitMaster");
    } catch (error) {
      toast.error(error.message || "🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Unit Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Code <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={unitData.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Description <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={unitData.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Unit Type <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Select
                      name="type"
                      value={unitData.type}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Unit Type</option>
                      {unitTypes.map((unit) => (
                        <option key={unit.value} value={unit.value}>
                          {unit.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Unit
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default UnitMaster;